<div class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Confirm {{ type | titlecase }} Deletion</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onCancel()" title="Close"></i>
  </div>
  <div class="modal-body">
    <p><strong>Are you sure you want to delete <span class="synchpc-primary">"{{ name }}"</span> {{ type }}?</strong></p>
    <p>All information associated to this {{ type }} will be permanently deleted.
    <span class="text-danger">This operation can not be undone.</span>
    </p>
    <p>Please type name of {{ type }} to confirm.</p>
    <input
      type="text"
      spellcheck="false"
      class="confirmInput"
      [(ngModel)]="inpVal"
    />
    <div style="margin-top: 5%">
      <mat-checkbox [(ngModel)]="skipCloud">Skip cloud deletion</mat-checkbox>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancel</button>
    <button type="button" class="btn btn-danger" [disabled]="inpVal != name" (click)="onSubmit()">Delete</button>
  </div>
</div>
